/**
 * **A08 · The key log** (Stream A, Paper.dc.html): every key on the ring, who has it, out and
 * back. It lives at the booth; the admin station reads it at Close the booths. The ring is every
 * key Festival Ops → Radios & keys has issued this year (CIDER keeps no list of keys apart from
 * their custody); a key out today prints who has it and when, the rest are lines to write on, and
 * six blank lines follow for a key handed out by hand.
 */
import { festivalDayWords } from './count_papers.js';
import type { PaperPage } from './paper_page.js';

/** A key's custody line, its times already in words (`1:58 PM`). */
export interface KeyLine {
  key: string;
  to: string;
  /** The operating day it went out (YYYY-MM-DD). */
  day: string;
  out: string;
  back: string | null;
  by: string;
}

/** `Lori Ruiz` → `LR`. */
const initials = (name: string): string =>
  name
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase())
    .join('');

export function keyLog(day: string, lines: KeyLine[]): PaperPage {
  const ring = [...new Set(lines.map((l) => l.key))];
  const today = lines.filter((l) => l.day === day);
  const rows = ring.map((key) => {
    // The key's latest custody today: who has it now, or who last had it.
    const l = today.filter((x) => x.key === key).at(-1);
    return l ? [key, l.to, l.out, l.back ?? '', initials(l.by)] : [key, '', '', '', ''];
  });
  const n = ring.length;
  return {
    title: 'Key log',
    sub: `${festivalDayWords(day)} · the booth · ${String(n)} ${n === 1 ? 'key' : 'keys'} on the ring`,
    qr: `KEYS ${festivalDayWords(day, true).slice(0, 3).toUpperCase()}`,
    blocks: [
      {
        head: '',
        cols: '120px 1fr 70px 70px 80px',
        rows: [
          ['KEY', 'ISSUED TO', 'OUT', 'BACK', 'BY'],
          ...rows,
          ...Array.from({ length: 6 }, () => ['', '', '', '', '']),
        ],
      },
    ],
    sign: ['Opened the ring', 'Closed the ring · keys still out listed on the back'],
    foot: 'Key log · a key out at Close the booths is on the admin station',
  };
}
